import { IScope } from "angular";

export class PedidoService {
  /**
   *
   * @param {IScope} $rootScope
   * @param {*} $state
   * @param {Q} $q
   * @param {*} PedidoResource
   * @param {*} localStorageService
   */
  constructor($rootScope, $state, $q, PedidoResource, localStorageService) {
    "ngInject";

    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$q = $q;
    this.resource = PedidoResource;
    this.lss = localStorageService;

    this.pedido = this.lss.get("ultimoPedido") || {
      remessas: [],
    };
  }

  atualizarPedido(novoPedido) {
    this.pedido = Object.assign({}, novoPedido);
    this.lss.set("ultimoPedido", this.pedido);
  }

  setPedido(pedido) {
    this.atualizarPedido(pedido);
  }

  getPedido() {
    //if(!this.pedido.id){
    this.getPedidoAsync(true);
    //}
    return this.pedido;
  }

  getPedidoId() {
    return this.pedido.id;
  }

  async getPedidoPorId(id) {
    return this.resource.getPedidoPorId({ id }).$promise;
  }

  /**
   * Obtém o último pedido
   *
   * @param {boolean} forceReload Força a atualização a partir da API
   */
  async getPedidoAsync(forceReload) {
    const token = this.lss.get("token");
    if (!token) {
      // No token means no session: drop the stored user too, or the next boot treats it as signed in
      // and loads customer data without a token.
      this.lss.remove("user");
      this.$state.go("login");
      throw new Error();
    }

    if (!forceReload && this.pedido.id) {
      return this.pedido;
    }

    try {
      const ultimoPedido = await this.resource.ultimaIncompleta().$promise;
      if (!ultimoPedido.remessas) {
        ultimoPedido.remessas = [];
      }

      if (forceReload || (ultimoPedido && ultimoPedido.id === this.pedido.id)) {
        this.atualizarPedido(ultimoPedido);
        return ultimoPedido;
      }

      this.$rootScope.$broadcast("pedido:criar-novo");
      throw new Error();
    } catch (e) {
      this.lss.remove("ultimoPedido");
      throw e;
    }
  }

  async atualizarObservacao(pedidoId, observacao) {
    return this.resource.atualizarObservacao({ pedidoId }, { observacao })
      .$promise;
  }

  async removerObservacao(pedidoId) {
    return this.resource.removerObservacao({ pedidoId }).$promise;
  }

  temPedidoAtivo() {
    return !!this.pedido.id;
  }

  temPedidoComRemessa() {
    return this.temPedidoAtivo() && this.pedido.remessas.length > 0;
  }

  novoPedido() {
    this.atualizarPedido({
      remessas: [],
    });

    this.$rootScope.$broadcast("etiqueta:destinatario:alterado", {});
    this.$rootScope.$broadcast("etiqueta:remetente:alterado", {});
  }

  async criar(pedido) {
    return this.resource.save(pedido).$promise;
  }

  async atualizar(orderId, pedido) {
    return this.resource.save({ orderId }, pedido).$promise;
  }

  async cancelar(orderId) {
    const data = await this.resource.delete({ orderId }).$promise;

    this.lss.remove("codigoCupom");

    return data;
  }

  async buscarResumo(orderId) {
    return this.resource.resumo({ orderId }).$promise;
  }

  async ultimaIncompleta() {
    return this.resource.ultimaIncompleta().$promise;
  }

  async ordemServicoAcompanhamento() {
    return this.resource.ordemServicoAcompanhamento().$promise;
  }

  atualizarEnderecoPedido(enderecos) {
    for (let i = 0; i < enderecos.length; i++) {
      const endereco = enderecos[i];

      if (endereco.ativo) {
        this.pedido.endereco = endereco;
        if (endereco && endereco.etiqueta) {
          this.pedido.enderecoEtiqueta = endereco.etiqueta;
        } else {
          this.pedido.enderecoEtiqueta = null;
        }
        break;
      }
    }
  }

  async atualizarEndereco(orderId, idEndereco) {
    return this.resource.atualizarEndereco({ orderId }, { idEndereco })
      .$promise;
  }

  async redirecionar() {
    try {
      const ultimaIncompleta = await this.ultimaIncompleta();
      this.setPedido(ultimaIncompleta);
      this.atualizarEnderecoPedido(ultimaIncompleta.endereco);
    } catch (e) {
      this.novoPedido();
    } finally {
      this.$state.go("home");
    }
  }

  async obterOpcoes(cep) {
    return this.resource.obterOpcoes({ cep }).$promise;
  }

  async obterOpcoesComPreco(dados) {
    return this.resource.obterOpcoesComPreco({
      cep: dados.cepDestino,
      peso: dados.peso,
      largura: dados.largura,
      altura: dados.altura,
      comprimento: dados.comprimento,
    }).$promise;
  }

  async obterDadosCheckout(orderId) {
    return this.resource.obterDadosCheckout({ orderId }).$promise;
  }

  async printLabel(codigos) {
    return this.resource.printLabel({ codigos }).$promise;
  }

  async printLabelEmLote(id) {
    return this.resource.printLabelEmLote({ id }).$promise;
  }

  async packageTracking(id) {
    return this.resource.packageTracking({ id }).$promise;
  }

  async dismiss(id) {
    return this.resource.dismiss({ id }).$promise;
  }

  async undoDismiss(id) {
    return this.resource.undoDismiss({ id }).$promise;
  }

  async visibleToggle(id) {
    return this.resource.visibleToggle({ id }).$promise;
  }

  async updateNFE(id, nfe) {
    return this.resource.updateNFE({ id, nfe }).$promise;
  }

  async updateEndereco(id, endereco) {
    return this.resource.updateEndereco({ id }, endereco).$promise;
  }

  async updateSituation(id, zendeskTicketId) {
    return this.resource.updateSituation({ id }, { zendeskTicketId }).$promise;
  }

  async getChegouMandae(unidadeId) {
    return this.resource.getChegouMandae({ unidadeId }).$promise;
  }

  cadastroManual(dados) {
    return this.resource.cadastroManual(dados).$promise;
  }

  datasProximasUteis(limit, offset) {
    return this.resource.datasProximasUteis({ limit, offset }).$promise;
  }

  async getDivergenciaMaisRecente(id) {
    return this.resource.getDivergenciaMaisRecente({ id }).$promise;
  }

  printRomaneio(params) {
    return this.resource.printRomaneio(params);
  }
}
